import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
	root: {
		margin: '0 5%',
		[theme.breakpoints.up('md')]: {
			margin: '0 30px'
		}
	},
	withPadding: {
		padding: `${6 * theme.spacing.unit}px 0`
	}
});

const CenteredContent = props => {
	const { classes, children, className, padding = true } = props;
	return (
		<div className={classNames(classes.root, className, padding && classes.withPadding)}>
			{children}
		</div>
	);
};

CenteredContent.propTypes = {
	classes: PropTypes.object,
	children: PropTypes.node,
	className: PropTypes.string,
	padding: PropTypes.bool
};

export default withStyles(styles)(CenteredContent);


// WEBPACK FOOTER //
// ./src/components/CenteredContent/CenteredContent.js